import React from "react";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Drawer,
  Stack,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { CATEGORY_TILE_CONFIGS, getLogTypeByCategory } from "../../constants/logTypeRegistry";
import { THERAPY_PREP_FILTERS } from "./reportBuilders/dailyCareReportEntryUtils";

const FILTER_ICON_MAP = CATEGORY_TILE_CONFIGS.reduce((acc, item) => {
  acc[item.key] = item.icon || null;
  acc[item.category] = item.icon || null;
  return acc;
}, {});

const getFilterIconComponent = (key) => {
  if (key === "notes") {
    return getLogTypeByCategory("dailyLog")?.iconComponent || DescriptionOutlinedIcon;
  }

  if (key === "medication") {
    return FILTER_ICON_MAP.meds || FILTER_ICON_MAP.medication || getLogTypeByCategory("medication")?.iconComponent || null;
  }

  return FILTER_ICON_MAP[key] || getLogTypeByCategory(key)?.iconComponent || null;
};

const DailyCareReportFiltersDrawer = ({
  isMobile,
  open,
  onClose,
  selectedFilters,
  toggleFilter,
  clearFilters,
  selectAllFilters,
  theme,
}) => (
  <Drawer
    anchor={isMobile ? "bottom" : "right"}
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        width: isMobile ? "100%" : 360,
        maxHeight: isMobile ? "72vh" : "100%",
        borderTopLeftRadius: isMobile ? 18 : 0,
        borderTopRightRadius: isMobile ? 18 : 0,
        px: 2,
        py: 2,
      },
    }}
  >
    <Stack spacing={2}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Filters
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Optional activity filters
          </Typography>
        </Box>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Done
        </Button>
      </Box>

      <Divider />

      <Stack spacing={0.5}>
        {THERAPY_PREP_FILTERS.map((item) => {
          const IconComponent = getFilterIconComponent(item.key);

          return (
            <Box
              key={item.key}
              onClick={() => toggleFilter(item.key)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.25,
                p: 1,
                borderRadius: 2,
                cursor: "pointer",
                bgcolor: selectedFilters.includes(item.key) ? alpha(theme.palette.primary.main, 0.05) : "transparent",
              }}
            >
              <Checkbox checked={selectedFilters.includes(item.key)} />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.1 }}>
                {IconComponent ? (
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: "8px",
                      bgcolor: alpha(theme.palette.semantic?.sageMist || theme.palette.primary.main, 0.72),
                      color: theme.palette.semantic?.sageDeep || theme.palette.primary.main,
                      display: "grid",
                      placeItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    <IconComponent sx={{ fontSize: 14 }} />
                  </Box>
                ) : null}
                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                  {item.label}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Stack>

      <Box sx={{ display: "flex", gap: 1 }}>
        <Button variant="outlined" fullWidth onClick={clearFilters} sx={{ textTransform: "none" }}>
          Clear
        </Button>
        <Button variant="contained" fullWidth onClick={selectAllFilters} sx={{ textTransform: "none" }}>
          Select All
        </Button>
      </Box>
    </Stack>
  </Drawer>
);

export default DailyCareReportFiltersDrawer;
